import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const NotificationsContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Noto Sans Thai', sans-serif !important;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: 400;
    color: #666666;
  }
`;

const Header = styled.div`
  background: white;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const ProfileImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

const ProfileName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #666;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const PageHeader = styled.div`
  background-color: #00BBD3;
  padding: 16px 24px;
  color: white;
  font-size: 18px;
  font-weight: 600;
  font-family: 'Noto Sans Thai', sans-serif !important;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const Content = styled.div`
  padding: 24px;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const NotificationCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const NotificationHeader = styled.div`
  background: #00BBD3;
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 400;
`;

const NotificationIcon = styled.div`
  width: 20px;
  height: 20px;
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

const NotificationContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

const NotificationImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
  flex-shrink: 0;
`;

const NotificationDivider = styled.div`
  width: 1px;
  height: 45px;
  background-color: #d0d0d0;
  flex-shrink: 0;
  margin: 0 4px;
`;

const NotificationText = styled.div`
  flex: 1;
`;

const NotificationTitle = styled.h3`
  font-size: 16px;
  font-weight: 400;
  color: #8C8C8C;
  margin: 0 0 8px 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const NotificationDescription = styled.p`
  font-size: 14px;
  color: #8C8C8C;
  line-height: 1.5;
  margin: 0 0 8px 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
  font-weight: 400;
`;

const NotificationTime = styled.span`
  font-size: 12px;
  color: #8C8C8C;
  font-family: 'Noto Sans Thai', sans-serif !important;
  font-weight: 400;
`;

const NotificationsPage = () => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate('/profile-edit');
  };

  const BellIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z" fill="white"/>
    </svg>
  );

  const notifications = [
    {
      id: 1,
      type: 'health-report',
      icon: <BellIcon />,
      title: 'ผลการตรวจสุขภาพของคุณ',
      description: 'กดดาวน์โหลด PDF',
      time: '1 ม.ค. 2025 | 10:12',
      image: './PDF.png'
    },
    {
      id: 2,
      type: 'health-report',
      icon: <BellIcon />,
      title: 'ผลการตรวจสุขภาพของคุณ',
      description: 'กดดาวน์โหลด PDF',
      time: '3 ม.ค. 2025 | 10:12',
      image: './PDF.png'
    },
    {
      id: 3,
      type: 'appointment',
      icon: <BellIcon />,
      title: 'มีนัดฉีดวัคซีนไข้หวัดใหญ่',
      description: 'วันที่ 23/10/2525',
      time: '3 ม.ค. 2025 | 10:12',
      image: './เข็มฉีดยา.png'
    }
  ];

  return (
    <NotificationsContainer>
      <Header>
        <HeaderLeft>
          <Logo src="./logo.png" alt="MFU Logo" />
          <HeaderTitle>MFU Wellness Center</HeaderTitle>
        </HeaderLeft>
        <ProfileContainer onClick={handleProfileClick}>
          <ProfileName>พงษ์ชัย</ProfileName>
          <ProfileImage src="./person.png" alt="Profile" />
        </ProfileContainer>
      </Header>

      <PageHeader>
        แจ้งเตือน
      </PageHeader>

      <Content>
        {notifications.map(notification => (
          <NotificationCard key={notification.id}>
            <NotificationHeader>
              <NotificationIcon>{notification.icon}</NotificationIcon>
              {notification.type === 'health-report' ? 'ผลการตรวจสุขภาพ' : 'กำหนดนัดฉีดวัคซีน'}
            </NotificationHeader>
            
            <NotificationContent>
              <NotificationImage src={notification.image} alt="" />
              <NotificationDivider />
              <NotificationText>
                <NotificationTitle>{notification.title}</NotificationTitle>
                <NotificationDescription>{notification.description}</NotificationDescription>
                <NotificationTime>{notification.time}</NotificationTime>
              </NotificationText>
            </NotificationContent>
          </NotificationCard>
        ))}
      </Content>
    </NotificationsContainer>
  );
};

export default NotificationsPage;